import React, { Component } from 'react';
import styled from 'styled-components';
import { Field } from 'formik';
import { Input, TextArea } from 'freemium-ui';

type TextInputProps = {
  name: string,
  placeholder?: string,
  type?: string,
  disabled?: boolean,
  label?: string,
  required?: any,
  className: string
};

class TextInput extends Component<TextInputProps> {
  static defaultProps = {
    type: 'text'
  };

  render() {
    const {
      type,
      name,
      label,
      placeholder,
      required = false,
      disabled
    } = this.props;
    return (
      <Field name={name}>
        {({ innerRef, field, form, ...props }) => {
          // const isTouched = form.touched[name]
          // const error = form.errors[name] || ''
          const error = form.touched[name] && form.errors[name];

          if (type === 'textarea') {
            return (
              <TextArea
                ref={innerRef}
                name={name}
                id={name}
                isRequired={required}
                isErrored={!disabled && !!error && form.submitCount > 0}
                placeholder={placeholder}
                errorText={error}
                autoComplete="off"
                label={label}
                {...field}
              />
            );
          }

          return (
            <Input
              ref={innerRef}
              name={name}
              id={name}
              isRequired={required}
              isErrored={!disabled && !!error && form.submitCount > 0}
              placeholder={placeholder}
              errorText={error}
              autoComplete="off"
              label={label}
              {...field}
            />
          );
        }}
      </Field>
    );
  }
}

const FreshworksStyledTextInput = styled(TextInput)`
  width: 100%;

  &[disabled] {
    pointer-events: none;
    color: ${({ theme: { colors } }) => colors.text.disabled};
    border-color: ${({ theme: { colors } }) => colors.border.disabled};
    background-color: ${({ theme: { colors } }) => colors.input.disabled};
    font-weight: ${({
      theme: {
        typography: { input }
      }
    }) => input.disabled.fontWeight};
  }

  &[data-has-error] {
    border-color: red;
    border-color: ${({ theme: { colors: border } }) => border.error};
    background-color: ${({ theme: { colors: background } }) =>
      background.error};
  }

  &[type='password'] {
    letter-spacing: 5px;
    font-size: 20px;
  }
`;

export default FreshworksStyledTextInput;
